<template>
    <div class="notification-toggles">
        <div class="toggle-group">
            <h4>Real-Time</h4>
            <app-form-item label="Late Email" prop="late_email">
                <span class="description">Emails that go out during class if a student is late from the class.</span>
                <app-radio-group v-model="value.late_email">
                    <app-radio :label="0">None</app-radio>
                    <app-radio :label="1">Everyone</app-radio>
                    <app-radio :label="2">Only At Risk</app-radio>
                </app-radio-group>
            </app-form-item>
            <app-form-item label="Absent Email" prop="absent_email">
                <span class="description">Emails that go out during class if a student is absent from the class.</span>
                <app-radio-group v-model="value.absent_email">
                    <app-radio :label="0">None</app-radio>
                    <app-radio :label="1">Everyone</app-radio>
                    <app-radio :label="2">Only At Risk</app-radio>
                </app-radio-group>
            </app-form-item>
            <app-form-item v-if="!onboarding" label="Alert Filter">
                <span class="description">Filter what students you receive real-time alerts for based on a given team.</span>
                <app-tag v-if="filter" closable @close="removeFilter">{{ filter.name }}</app-tag>
                <app-button v-else @click="showPicker = true">Pick Team</app-button>

                <team-picker v-model="showPicker" @selected-team="addFilter">
                    <template slot="title">Select Team</template>
                </team-picker>

                <span v-if="filter" class="description sub-description">You will only receive notifications for students that are in {{ filter.name }}.</span>
            </app-form-item>
            <app-form-item v-if="value.phone_number" label="Text Message Notifications" prop="prefers_sms">
                <span class="description">Receive tardy and absent notifications over text message instead of email.</span>
                <app-switch 
                    id="prefers_sms" 
                    v-model="value.prefers_sms" 
                    active-text="Yes"
                    inactive-text="No"/>
                <span class="description sub-description">Message and data rates may apply. Messages delivered from: (828) 392-5595</span>
            </app-form-item>
        </div>

        <div class="toggle-group">
            <h4>Summary & Troubleshooting</h4>
            <app-form-item label="Pindrop Email" prop="pindrop_email">
                <span class="description">Emails that are sent when a student sends a pindrop of their location on a map.</span>
                <app-switch 
                    id="pindrop_email" 
                    v-model="value.pindrop_email" 
                    active-text="Yes"
                    inactive-text="No"/>
            </app-form-item>
            <app-form-item label="Daily Recap Email" prop="daily_recap_email">
                <span class="description">An email that goes out towards the end of the day recapping all of the issues during the day.</span>
                <app-switch 
                    id="daily_recap_email" 
                    v-model="value.daily_recap_email" 
                    active-text="Yes"
                    inactive-text="No"/>
            </app-form-item>
            <app-form-item label="Weekly Startup Email" prop="weekly_startup_email">
                <span class="description">A Monday morning email providing you a list of things to tackle during the week.</span>
                <app-switch 
                    id="weekly_startup_email" 
                    v-model="value.weekly_startup_email" 
                    active-text="Yes"
                    inactive-text="No"/>
            </app-form-item>
            <app-form-item label="Weekly Recap Email" prop="weekly_recap_email">
                <span class="description">A Friday afternoon email summarizing the week and how your students have done.</span>
                <app-switch 
                    id="weekly_recap_email" 
                    v-model="value.weekly_recap_email" 
                    active-text="Yes"
                    inactive-text="No"/>
            </app-form-item>
        </div>
    </div>
</template>

<script>
import Panel from '../../ui/Panel'
import Team from '@/store/models/Team'
import TeamPicker from '../Team/TeamPicker'

export default {
    name: 'users-notifications',
    components: {
        Panel,
        TeamPicker
    },
    props: ['value', 'onboarding'],
    data() {
        return {
            showPicker: false
        }
    },
    computed: {
        filter() {
            return Team.find(this.value.alert_filter)
        }
    },
    methods: {
        removeFilter() {
            this.value.alert_filter = null
        },
        addFilter(team) {
            this.value.alert_filter = [ team.id ]
        }
    }
}
</script>

<style lang="stylus">
@import '../../../stylus/variables'

    .notification-toggles
        .toggle-group
            margin: 0px -20px

            h4
                background: $lighter-grey
                padding: 15px 30px 15px
                display: block
                font-weight: 500
                font-size: 17px
                border-bottom: 1px solid $light-border-color
                border-top: 1px solid $light-border-color
            &:first-child h4
                border-top-width: 0

        .app-form-item
            padding: 0px 30px
            label
                float: none
                display: inline-block
                text-align: left
                margin-bottom: 5px
                font-size: 15px
                color: $text-dark-grey
                font-weight: 500
            span.description
                color: $text-medium-grey
                display: block
                line-height: 16px
                padding-bottom: 10px
                margin-top: -5px
                &.sub-description
                    margin-top: 10px
                    margin-bottom: 5px
                    color: $text-medium-grey
                    font-size: 12px
            .app-form-item__content
                display: inline-block
            .el-radio__input+.el-radio__label
                vertical-align: top
            &:last-child
                border-bottom-width: 0px
</style>
